function getHTMLAsNode(e){var n=document.createElement("div");return n.innerHTML=e,n.firstChild}